import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-rent-fleet',
    templateUrl: './rent-fleet.component.html',
    styleUrls: ['./rent-fleet.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RentFleetComponent {

}
